import { XSnackbar } from '@adornis/chemistry/elements/components/x-snackbar.js';
import { stateful, useState } from '@adornis/functional-lit/stateful.js';
import { useQuery } from '@adornis/functional-lit/use-query.js';
import { html, nothing } from 'lit';
import * as m from '../../../../localization/out/messages.js';
import { subscribeMatchingWeekSettings } from '../../../api/settings.js';
import { MatchingWeekSettings } from '../../../db/settings.js';

export const AdminApplicationPhase = stateful(() => {
  const [saving, setSaving] = useState(false, []);
  const settingsQuery = useQuery(
    () =>
      subscribeMatchingWeekSettings()({
        _id: 1,
        applicationPhaseClosed: 1,
        companyRegistrationClosed: 1,
      }),
    [],
  );

  const handleSave = async () => {
    if (!settingsQuery.value) return;
    setSaving(true);
    try {
      await (settingsQuery.value as MatchingWeekSettings).save();
      void XSnackbar.show(m.admin_application_phase_saved());
    } catch (error) {
      console.error(error);
      void XSnackbar.show(error instanceof Error ? error.message : m.submit_application_unknown_error());
    } finally {
      setSaving(false);
    }
  };

  return html`
    <div class="p-4 sm:p-8 flex flex-col items-center">
      <div class="max-w-4xl w-full">
        ${
          settingsQuery.loading
            ? html`<div class="flex justify-center py-8"><span class="loading loading-spinner loading-lg"></span></div>`
            : nothing
        }
        ${
          settingsQuery.value
            ? html`
                <div class="card bg-base-100 shadow-xl">
                  <div class="card-body">
                    <h2 class="card-title text-2xl mb-4">${m.admin_application_phase_title()}</h2>
                    <label class="label cursor-pointer justify-start gap-4">
                      <input
                        type="checkbox"
                        class="toggle toggle-primary"
                        .checked=${settingsQuery.value.applicationPhaseClosed === false}
                        ?disabled=${saving}
                        @change=${(event: Event) => {
                          if (!settingsQuery.value) return;
                          settingsQuery.value.applicationPhaseClosed = !(event.currentTarget as HTMLInputElement)
                            .checked;
                        }}
                      />
                      <span class="label-text font-semibold">${m.admin_application_phase_toggle_label()}</span>
                    </label>
                    <p class="text-sm text-base-content/70 mt-2">${m.admin_application_phase_hint()}</p>

                    <div class="divider"></div>

                    <label class="label cursor-pointer justify-start gap-4">
                      <input
                        type="checkbox"
                        class="toggle toggle-primary"
                        .checked=${settingsQuery.value.companyRegistrationClosed !== true}
                        ?disabled=${saving}
                        @change=${(event: Event) => {
                          if (!settingsQuery.value) return;
                          settingsQuery.value.companyRegistrationClosed = !(event.currentTarget as HTMLInputElement)
                            .checked;
                        }}
                      />
                      <span class="label-text font-semibold">${m.admin_company_registration_toggle_label()}</span>
                    </label>
                    <p class="text-sm text-base-content/70 mt-2">${m.admin_company_registration_hint()}</p>

                    <div class="flex justify-end mt-6">
                      <button class="btn btn-primary" ?disabled=${saving} @click=${handleSave}>
                        <span class="icon-[material-symbols--save]"></span>
                        ${m.save()}
                      </button>
                    </div>
                  </div>
                </div>
              `
            : nothing
        }
      </div>
    </div>
  `;
});
